import { FC, PropsWithChildren, useEffect, useRef } from 'react';
import { createPortal } from "react-dom";
import styled from "styled-components";
import { motion } from "framer-motion";

const Overlay = styled(motion.div)<{ $zIndex?: number }>`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${({ theme, $zIndex }) => $zIndex || theme.zIndex[10]};
  width: 100%;
  height: 100vh;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: rgba(0, 0, 0, 0.15);
`;

export const modalRoot = document.getElementById("modals-root");

interface Props {
  zIndex?: number;
  stopPropagation?: boolean;
  className?: string;
}

export const Modal: FC<PropsWithChildren<Props>> = ({
  children,
  zIndex,
  stopPropagation = true,
  className,
}) => {
  const ref = useRef(document.createElement("div"));

  useEffect(() => {
    const el = ref.current;

    modalRoot!.appendChild(el);

    return () => {
      modalRoot!.removeChild(el);
    };
  }, []);

  return createPortal(
    <Overlay
      className={className}
      onClick={(e) => {
        stopPropagation && e.stopPropagation();
      }}
      $zIndex={zIndex}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      {children}
    </Overlay>,
    ref.current
  );
};
